import { render } from "./BusinessModelDriverDetail.vue?vue&type=template&id=13791a82&scoped=true&ts=true"
import script from "./BusinessModelDriverDetail.vue?vue&type=script&lang=ts"
export * from "./BusinessModelDriverDetail.vue?vue&type=script&lang=ts"

import "./BusinessModelDriverDetail.vue?vue&type=style&index=0&id=13791a82&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13791a82"]])

export default __exports__